import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import { searchLocations, selectLocationFilter, resetFilter } from '../locations';
import Input from '../../../ui/Input';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Search.scss';

@injectIntl
export class Search extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        filter: PropTypes.string,
        intl: intlShape.isRequired,
    }

    componentWillUnmount() {
        this.props.dispatch(resetFilter());
    }

    handleOnChange = (e) => {
        this.props.dispatch(searchLocations(e.target.value));
    }

    render() {
        const { filter } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Input
                className={styles.search}
                onChange={this.handleOnChange}
                placeholder={formatMessage({ id: 'frontend.addressbook.text.filter' })}
                type='search'
                value={filter || ''}
            />
        );
    }
}

export default connect(state => ({
    filter: selectLocationFilter(state),
}))(Search);
